<template>
  <div class="dialog-wrap">
    <div @click="openDialog">
      <slot></slot>
    </div>
    <el-drawer
      title="批量修改"
      :visible.sync="dialogVisible"
      direction="rtl"
      :size="520"
      destroy-on-close
      append-to-body
    >
      <div class="content-wrap">
        <div class="dialog-title">
          <p class="title">修改课程顾问</p>
          <p class="total">已选择{{ originArray.length }}人</p>
        </div>
        <el-form
          class="main-form"
          size="mini"
          :model="form"
          ref="mainForm"
          label-width="110px"
        >
          <el-form-item label="课程顾问:">
            <el-select
              v-model.number="form.staff_id"
              filterable
              clearable
              placeholder="请选择"
            >
              <el-option
                v-for="item in staffList"
                :key="item.staff_id"
                :label="item.name"
                :value="item.staff_id"
              ></el-option>
            </el-select>
          </el-form-item>
        </el-form>
        <div class="footer">
          <div class="btns">
            <div class="mwow-button-filled mini" @click="closeDialog">取消</div>
            <div class="mwow-button-filled mini success" @click="handleSubmit">
              保存
            </div>
          </div>
        </div>
      </div>
    </el-drawer>
  </div>
</template>
<script>
import { staffList } from "@/api/globalSearch";
import { DistributeFollowStaffApi } from "@/api/lesson";
export default {
  // @Prop() ori!: any[];
  props: ["ori"],
  data() {
    return {
      originArray: [],
      staffList: [],
      form: {
        staff_id: "",
      },
      dialogVisible: false,
      rules: {
        staff_id: [
          { required: true, message: "请选择课程顾问", trigger: "change" },
        ],
      },
    };
  },
  methods: {
    openDialog() {
      if (this.ori.length === 0) {
        return false;
      }
      this.form = {
        staff_id: "",
      };
      this.dialogVisible = true;
      this.originArray = [...this.ori];
      staffList({ page: 1, page_size: 500, job_ids: [3], status: 1 }).then(
        (res) => {
          if (res.error_code === 0) {
            this.staffList = res.data.list;
          }
        }
      );
    },

    closeDialog() {
      this.dialogVisible = false;
    },

    handleSubmit() {
      this.$refs["mainForm"].validate((valid) => {
        if (valid) {
          const arr = [];
          this.originArray.map((item) => {
            arr.push(item.student_id);
          });
          const params = {
            student_ids: arr,
            follow_staff_id: this.form.staff_id,
          };
          DistributeFollowStaffApi(params).then(() => {
            this.$message({
              type: "success",
              message: "编辑完成",
            });
            this.closeDialog();
            this.$emit("change");
          });
        }
      });
    },
  },
};
</script>
<style lang="scss" scoped>
.dialog-wrap {
  display: inline-block;
}
.content-wrap {
  height: 100%;
  display: flex;
  flex-direction: column;
  .dialog-title {
    padding: 20px 0;
    margin: 0 47px;
    border-bottom: 1px dashed #e7e8ea;
    .title {
      font-size: 14px;
      line-height: 18px;
      color: #5c5d5e;
      margin-bottom: 17px;
      font-weight: bold;
    }
    .total {
      font-size: 12px;
      line-height: 16px;
      color: #ffb940;
    }
  }
  .main-form {
    flex: 1;
    padding: 16px 0;
    .tail {
      margin-left: 6px;
      color: #5c5d5e;
      font-size: 12px;
    }
  }
  .footer {
    padding: 20px;
    .btns {
      text-align: right;
      .mwow-button-filled {
        margin-left: 10px;
      }
    }
  }
}
</style>
